import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'article-wcq-2026': 'https://readdy.ai/api/search-image?query=Professional%20soccer%20match%20scene%20with%20players%20in%20action%20on%20green%20field%2C%20dramatic%20stadium%20lighting%2C%20warm%20golden%20tones%2C%20editorial%20sports%20photography%20style%2C%20shallow%20depth%20of%20field%2C%20cinematic%20motion%20blur%2C%20clean%20background&width=800&height=400&seq=article-wcq-2026&orientation=landscape',
  'article-nba-preview': 'https://readdy.ai/api/search-image?query=Dynamic%20basketball%20game%20action%20with%20player%20dunking%2C%20dramatic%20arena%20lighting%2C%20warm%20orange%20and%20red%20tones%2C%20editorial%20sports%20photography%2C%20motion%20capture%2C%20clean%20background%2C%20professional%20composition&width=800&height=400&seq=article-nba-preview&orientation=landscape',
  'article-wimbledon-2026': 'https://readdy.ai/api/search-image?query=Elegant%20tennis%20match%20on%20grass%20court%20with%20player%20serving%2C%20warm%20sunlight%2C%20classic%20Wimbledon%20aesthetic%2C%20editorial%20sports%20photography%2C%20shallow%20depth%20of%20field%2C%20clean%20green%20background&width=800&height=400&seq=article-wimbledon-2026&orientation=landscape',
  'article-lol-s16': 'https://readdy.ai/api/search-image?query=Epic%20esports%20arena%20with%20dramatic%20stage%20lighting%20and%20large%20screens%2C%20competitive%20gaming%20atmosphere%2C%20neon%20red%20and%20gold%20accents%2C%20cinematic%20wide%20shot%2C%20crowded%20venue%2C%20professional%20photography&width=800&height=400&seq=article-lol-s16&orientation=landscape',
  'article-ucl-draw': 'https://readdy.ai/api/search-image?query=European%20champions%20league%20trophy%20and%20stadium%20atmosphere%2C%20dramatic%20night%20lighting%2C%20golden%20and%20deep%20red%20tones%2C%20editorial%20sports%20photography%2C%20cinematic%20composition%2C%20star%20field%20lights&width=800&height=400&seq=article-ucl-draw&orientation=landscape',
  'article-register-guide': 'https://readdy.ai/api/search-image?query=Modern%20digital%20sports%20platform%20interface%20with%20warm%20lighting%2C%20sleek%20design%20aesthetic%2C%20red%20and%20gold%20accents%2C%20clean%20professional%20look%2C%20abstract%20sports%20background%2C%20soft%20gradients&width=800&height=400&seq=article-register-guide&orientation=landscape',
  'article-csl-midseason': 'https://readdy.ai/api/search-image?query=Chinese%20Super%20League%20soccer%20match%20with%20players%20competing%2C%20packed%20stadium%2C%20dramatic%20daylight%2C%20warm%20golden%20hour%20lighting%2C%20editorial%20sports%20photography%2C%20vibrant%20atmosphere&width=800&height=400&seq=article-csl-midseason&orientation=landscape',
  'article-fiba-china': 'https://readdy.ai/api/search-image?query=Chinese%20national%20basketball%20team%20in%20action%20during%20international%20game%2C%20dramatic%20arena%20lighting%2C%20red%20and%20gold%20team%20colors%2C%20editorial%20sports%20photography%2C%20motion%20capture%2C%20professional%20composition&width=800&height=400&seq=article-fiba-china&orientation=landscape',
};

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 6);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新体育资讯
            </h2>
            <p className="mt-2 text-sm text-foreground-500">专业赛事分析与行业深度解读</p>
          </div>
          <Link
            to="/category/football"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            阅读更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={articleImages[article.imageSeq]}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-semibold text-foreground-800 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200/60">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-xs text-foreground-400">
                    <i className="ri-eye-line mr-1"></i>
                    {article.readCount.toLocaleString()} 阅读
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/football"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 cursor-pointer"
          >
            阅读更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}